import { useEffect, useState } from 'react';

const links = [
  { label: '实时速递', href: '#realtime' },
  { label: '今日热榜', href: '#hotlist' },
  { label: '分类栏目', href: '#column' },
  { label: '关于我们', href: '#about' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      {/* utility strip */}
      <div className="hidden md:block border-b border-background-200/70">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-1.5 flex items-center justify-between text-xs text-foreground-600">
          <p className="flex items-center gap-2">
            <i className="ri-calendar-line text-accent-600"></i>
            全网娱乐热点 · 持续滚动中
          </p>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-flashlight-line text-primary-500"></i> 第一手消息
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-send-line text-accent-600"></i> 独家速递
            </span>
          </div>
        </div>
      </div>

      {/* main nav */}
      <nav className="mx-auto max-w-7xl px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <a href="#home-top" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center font-display text-lg shadow-soft">
              瓜
            </span>
            <span className="leading-none">
              <span className="block font-heading text-2xl font-black text-foreground-950 tracking-tight">最快吃瓜</span>
              <span className="block text-[11px] tracking-[0.2em] text-primary-600 mt-0.5">第一手 · 独家 · 秒级</span>
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="px-3.5 py-2 text-sm font-medium text-foreground-800 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <span className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              24h 在线速递
            </span>
            <a
              href="#contact"
              className="hidden sm:inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition whitespace-nowrap"
            >
              订阅快讯 <i className="ri-arrow-right-up-line"></i>
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-900"
            >
              <i className={`${open ? 'ri-close-line' : 'ri-menu-3-line'} text-xl`}></i>
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="lg:hidden mt-3 pb-3 grid grid-cols-2 gap-2 sm:hidden rounded-xl bg-background-50 border border-background-200/70 p-2">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 rounded-lg bg-background-100 text-sm text-foreground-800 text-center hover:bg-primary-50 hover:text-primary-600 whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}